import planApi from "../../../../api/planApi.js";
import { HudGlobal } from "../../../../util/HudGlobal.js";
import StoreDBManger from "../../../../util/StoreDBManger.js";
import { gotoHomeList } from "../../../middle-ware/utils/ControlRouter.js";
import LoginForceOutSureDialog from "../login-force-out-sure-dialog/Index.vue";
import { getTrainTypeTitle, loadSignOutValidUser } from "../util/trainDialogUtil.js";

// 情况三、现场学习准备页面-结束培训记录时，有学员未签退
export default {
    name: "EndTrainDialog",
    components: { LoginForceOutSureDialog },
    props: {
        propDialogVisible: Boolean,
        propDialogObject: Object,
    },
    data() {
        const validateRequirePasswd = (rule, value, callback) => {
            const rules = /^(\w){6,18}$/;
            if (!rules.test(value)) {
                callback(new Error("请输入6-18位的正确密码"));
            } else if (this.passWordError) {
                callback(new Error("密码错误,请重新输入"));
            }
            callback();
        };
        return {
            ruleForm: {
                passWord: "", // 密码
            },
            dialogVisible: false, // 弹窗是否显示
            rules: {
                passWord: [{ required: true, trigger: "change", validator: validateRequirePasswd }],
            },
            passWordError: false,
            iconImage: require("@assets/img/compulsory_end_train_icon.png"),
            // 情况三、现场学习准备页面-结束培训记录时，有学员未签退
            loginForceOutDialog: {
                visible: false, // 退出现场学习弹窗
            },
        };
    },
    watch: {
        propDialogVisible: {
            immediate: true,
            handler(value) {
                this.dialogVisible = value;
            },
        },
        propDialogObject: {
            immediate: true,
            handler(value) {
                if (value) {
                }
            },
            deep: true,
        },
    },
    computed: {
        // 获取培训类型标题
        getTrainTypeTitle() {
            return getTrainTypeTitle(this.propDialogObject);
        },
    },
    methods: {
        /**
         * 更改内容的时候，标识置为false
         */
        changePwd() {
            if (this.passWordError) {
                this.passWordError = false;
            }
        },
        /**
         * 关闭弹窗
         */
        closeDialog() {
            this.$emit("update:propDialogVisible");
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
            this.$emit("close-dialog");
        },
        // 关闭培训
        callForceOutSureDialogBack(val) {
            this.$emit("call-back", val);
        },
        /**
         * 确认退出
         */
        loginOut() {
            const that = this;
            this.$refs.ruleForm &&
                this.$refs.ruleForm.validate((valid, object) => {
                    if (valid) {
                        that.passwdVerity();
                    }
                });
        },
        passwdVerity() {
            const that = this;
            const params = {
                userId: that.$store.getters.userId,
                passwd: that.ruleForm.passWord,
            };
            planApi.passwdVerity(params).then((response) => {
                const { success, code } = response;
                if (success) {
                    this.$refs.ruleForm.validateField("passWord");
                    this.passWordError = true;
                    this.closeDialog();

                    // 有签退人员才进入强制签退
                    loadSignOutValidUser(this.propDialogObject, (data, res) => {
                        if (data) {
                            that.loginForceOutDialog.visible = true;
                            // 赋值页面数据
                        } else {
                            if (res.code == 80701) {
                                HudGlobal.showUniversalAlert(res.description).then(() => {
                                    that.closeDialog();
                                });
                            } else {
                                that.closeDialog();
                                HudGlobal.showMessage(res.description);
                            }
                        }
                    });
                } else if (code * 1 === 1) {
                    that.passWordError = true;
                    that.$refs.ruleForm.validateField("passWord");
                }
                that.loading = false;
            });
        },
    },
};
